module.exports = __webpack_public_path__ + "CG.png?2308cc7a23599573cbe44c48a1443740";